module.exports = __webpack_public_path__ + "school/img/jiaoshi3ji.38232e20.jpg";